/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { ConfigsPage } from '@/pages/Configs/ConfigsPage';

export function ConfigsRoute() {
  return <ConfigsPage />;
}
